import FormHeader from "@/components/FormHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/axios";
import { CustomPeriode, DataPendaftaran } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { RiSettings3Fill } from "react-icons/ri";

const setPeriodeCustom = async (data: CustomPeriode) => {
  const response = await api.post("/data-pendaftaran/set-periode-custom", data);
  return response.data;
};

export default function FormPeriodeCustom({
  selectedRow,
  closeModal,
}: {
  selectedRow: DataPendaftaran | null;
  closeModal: () => void;
}) {
  const [form, setForm] = useState<CustomPeriode>({
    id_data_pendaftaran: String(selectedRow?.id_data_pendaftaran) || "",
    custom_waktu_selesai_daftar_valid:
      selectedRow?.periode_custom?.custom_waktu_selesai_daftar_valid || "",
    custom_waktu_selesai_isi_ukt:
      selectedRow?.periode_custom?.custom_waktu_selesai_isi_ukt || "",
    custom_waktu_selesai_bayar_ukt:
      selectedRow?.periode_custom?.custom_waktu_selesai_bayar_ukt || "",
    custom_waktu_selesai_daftarkembali:
      selectedRow?.periode_custom?.custom_waktu_selesai_daftarkembali || "",
    custom_waktu_pengumuman_ukt:
      selectedRow?.periode_custom?.custom_waktu_pengumuman_ukt || "",
    custom_waktu_selesai_sanggah_berkas_daftarkembali:
      selectedRow?.periode_custom
        ?.custom_waktu_selesai_sanggah_berkas_daftarkembali || "",
    custom_waktu_selesai_konfirmasi_kipk:
      selectedRow?.periode_custom?.custom_waktu_selesai_konfirmasi_kipk || "",
  });

  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: setPeriodeCustom,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listDataPendaftaran"] });
      closeModal();
      toast.success(data?.message || "Success.");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
    },
  });

  const handleSaveCustomPeriode = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate(form);
  };

  return (
    <form onSubmit={handleSaveCustomPeriode} className="flex flex-col gap-y-3">
      <FormHeader title="Custom Periode" icon={<RiSettings3Fill />} />

      <div>
        <Label>Waktu Selesai Validasi Pendaftaran</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_daftar_valid}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_daftar_valid: event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Selesai Isi UKT</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_isi_ukt}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_isi_ukt: event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Selesai Bayar UKT</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_bayar_ukt}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_bayar_ukt: event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Selesai Daftarkembali</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_daftarkembali}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_daftarkembali: event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Selesai Sanggah Berkas Daftarkembali</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_sanggah_berkas_daftarkembali}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_sanggah_berkas_daftarkembali:
                event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Pengumuman UKT</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_pengumuman_ukt}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_pengumuman_ukt: event.target.value,
            }))
          }
        />
      </div>
      <div>
        <Label>Waktu Selesai Konfirmasi KIPK</Label>
        <Input
          type="datetime-local"
          value={form.custom_waktu_selesai_konfirmasi_kipk}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              custom_waktu_selesai_konfirmasi_kipk: event.target.value,
            }))
          }
        />
      </div>
      <div className="mt-5 flex gap-3">
        <Button
          disabled={isPending}
          variant={"outline"}
          onClick={() => closeModal()}
        >
          Batal
        </Button>
        <Button disabled={isPending}>
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Simpan"
          )}
        </Button>
      </div>
    </form>
  );
}
